import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

/**
 * Generated with generate-feature-flag-custom-hook.sh script
 * on 2025-01-22T00:00:00-0000.
 */
export function useBpMarkupChargeCodeEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.BpMarkupChargeCode,
    false
  );

  return Boolean(isEnabled);
}